<template>
  <fragment class="search-nav-year-month">
    <span class="title">{{ label }}</span>
    <div class="flex items-center gap-2" style="width: 160px"><search-nav-item-select v-model="year" :list="yearList" @change="onChangeData" />{{ yearAfter }}</div>
    <div v-if="!yearOnly" class="flex items-center gap-2" style="width: 100px"><search-nav-item-select v-model="month" :list="monthList" @change="onChangeData" />{{ monthAfter }}</div>
  </fragment>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
export default {
  name: "SearchNavYearMonth",
  components: { SearchNavItemSelect },
  props: {
    label: {
      default: "대상기간",
      type: String,
    },
    value: {
      type: Object,
      default: () => {
        return {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
        };
      },
    },
    yearOnly: {
      type: Boolean,
      default: false,
    },
    yearAfter: {
      type: String,
      default: "년",
    },
    monthAfter: {
      type: String,
      default: "월",
    },
    useAllYear: {
      type: Boolean,
      default: true,
    },
    useAllMonth: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    yearList() {
      let nowYear = new Date().getFullYear();
      const yearList = [];
      if (this.useAllYear) {
        yearList.push({ text: "전체", value: "" });
      }
      for (let i = 0; i < 50; i++) {
        yearList.push({ text: `${nowYear}`, value: nowYear });
        nowYear--;
      }
      return yearList;
    },
    monthList() {
      return [
        { text: "전체", value: "" },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" }
      ];
    },
  },
  data () {
    return {
      year: "",
      month: "",
    }
  },
  created () {
    this.year = this.value.year
    this.month = this.value.month
  },
  methods: {
    onChangeData () {
      this.$emit('input', {year:this.year, month:this.month})
      this.$emit('change', {year:this.year, month:this.month})
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}
.search-nav-year-month {
  display: flex;

  .year-month-title {
    white-space: nowrap;
  }

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 114px !important;
  }
}
</style>
